import { useDispatch } from 'store/hooks';
import { createWidgetSetColumnWidthAction } from 'widgets/store/grid/columnWidth/actions';
import { useWidgetContext } from 'widgets/WidgetContext';
import { useCallback, useMemo } from 'react';

export const useDispatchUpdateWidgetColumnWidth = <
    TColumnId extends string,
>() => {
    const { widgetType, widgetKey } = useWidgetContext();
    const dispatch = useDispatch();
    const actionCreator = useMemo(
        () =>
            createWidgetSetColumnWidthAction<TColumnId>(widgetType, widgetKey),
        [widgetType, widgetKey]
    );
    return useCallback(
        (columnId: TColumnId, width: number) =>
            dispatch(actionCreator(columnId, width)),
        [dispatch, actionCreator]
    );
};
